
define('text!templates/components/cd_role/cd_role.html',[],function () { return '<td data-cell="name">\n    <a href="/personal-roles/<%= id %>"><%= role_name %> </a>\n</td>\n\n\n';});

